import getAxios from "./axiosService";

const _searchHistoryKey = 'kkHisSearch';
const _searchVodHistoryKey = 'vodHisSearch';
let searchService = {
  initSearch () {
    return new Promise((resolve, reject) => {
      let axios = getAxios(true);
      axios.get(`/api/book/init_search`)
        .then(res => {
          if (res.status === 200){
            resolve(res.data);
          }else {
            console.error('get init search data error', res);
            reject();
          }
        })
    })
  },
  searchNovel(keyword){
    return new Promise((resolve, reject) => {
      let axis = getAxios();
      axis.post(`/api/novel/search?content=${keyword}`)
        .then(res => {
          if (res.status === 200) {
            resolve(res.data);
          }else{
            console.error('get search result data error', res);
            reject();
          }
        })
    })
  },
  searchBook(keyword){
    return new Promise((resolve, reject) => {
      let axis = getAxios();
      axis.post(`/api/book/search?content=${keyword}`)
        .then(res => {
          if (res.status === 200) {
            resolve(res.data);
          }else{
            console.error('get search result data error', res);
            reject();
          }
        })
    })
  },
  searchVod(keyword, page){
    return new Promise((resolve, reject) => {
      let axis = getAxios();
      axis.post(`/api/vod/search?content=${keyword}&currentPage=${page}`)
        .then(res => {
          if (res.status === 200) {
            resolve(res.data);
          }else{
            console.log(res.status)
            console.error('get search result data error', res);
            reject();
          }
        })
    })
  },
  setHistorySearch(keyword){
    let list = this.getHistorySearch();
    let index = list.findIndex(item => item === keyword)
    if (index > -1) {
      list.splice(index, 1)
    }
    list.unshift(keyword);
    if (list.length > 10){
      list.pop();
    }
    window.localStorage.setItem(_searchHistoryKey, list);
    return list;
  },
  setVodHistorySearch(keyword){
    let list = this.getVodHistorySearch();
    let index = list.findIndex(item => item === keyword)
    if (index > -1) {
      list.splice(index, 1)
    }
    list.unshift(keyword);
    if (list.length > 10){
      list.pop();
    }
    window.localStorage.setItem(_searchVodHistoryKey, list);
    return list;
  },
  getHistorySearch(){
    let hisSearch = window.localStorage.getItem(_searchHistoryKey);
    if (hisSearch) {
      return hisSearch.split(",");
    }
    return [];
  },
  getVodHistorySearch(){
    let hisSearch = window.localStorage.getItem(_searchVodHistoryKey);
    if (hisSearch) {
      return hisSearch.split(",");
    }
    return [];
  }
};
export default searchService;



// WEBPACK FOOTER //
// ./src/services/searchService.js